// ANDAMAN
import andaman1 from '../images/statewiseCards//Andaman/andaman1.png' 
// import andaman2 from '../images/statewiseCards//Andaman/andaman2.png'
import andaman4 from '../images/statewiseCards/Andaman/andaman4.png' 
import andaman3 from '../images/statewiseCards/Andaman/andaman3.jpeg' 
import andaman5 from '../images/statewiseCards/Andaman/andaman5.png' 
import andaman6 from '../images/statewiseCards/Andaman/andaman6.png' 
import andaman7 from '../images/statewiseCards/Andaman/andaman7.png' 
import andaman8 from '../images/statewiseCards/Andaman/andaman8.png' 
import andaman9 from '../images/statewiseCards/Andaman/andaman9.png' 
import andaman10 from '../images/statewiseCards/Andaman/andaman10.png' 
import andaman11 from '../images/statewiseCards/Andaman/andaman11.png' 
import andaman12 from '../images/statewiseCards/Andaman/andaman12.png'
import andaman13 from '../images/statewiseCards/Andaman/andaman13.png' 
import andaman14 from '../images/statewiseCards/Andaman/andaman14.png' 
import andaman15 from '../images/statewiseCards/Andaman/andaman15.png' 
import andaman16 from '../images/statewiseCards/Andaman/andaman16.png' 
import andaman17 from '../images/statewiseCards/Andaman/andaman17.png' 
import andaman18 from '../images/statewiseCards/Andaman/andaman18.png' 
import andaman19 from '../images/statewiseCards/Andaman/andaman19.png' 
import andaman20 from '../images/statewiseCards/Andaman/andaman20.png' 
import andaman21 from '../images/statewiseCards/Andaman/andaman21.png' 
import andaman22 from '../images/statewiseCards/Andaman/andaman22.png' 


// Char Dham
import chardham1 from '../images/statewiseCards/chardham/1.jpg' 
import chardham2 from '../images/statewiseCards/chardham/2.png' 

// Goa
import goa1 from '../images/statewiseCards/Goa/1.png'
import goa2 from '../images/statewiseCards/Goa/2.png'
import goa3 from '../images/statewiseCards/Goa/3.png'
import goa4 from '../images/statewiseCards/Goa/4.png'
import goa5 from '../images/statewiseCards/Goa/5.png'

// Golden Triangle
import goldenTriangle1 from '../images/statewiseCards/Golden Triangle/1.png'
import goldenTriangle2 from '../images/statewiseCards/Golden Triangle/2.png'
import goldenTriangle3 from '../images/statewiseCards/Golden Triangle/3.png'


// Kerala
import kerala1 from '../images/statewiseCards/Kerala/1.png';
import kerala2 from '../images/statewiseCards/Kerala/2.png';
import kerala3 from '../images/statewiseCards/Kerala/3.png';
import kerala4 from '../images/statewiseCards/Kerala/4.png';
import kerala5 from '../images/statewiseCards/Kerala/5.png';
import kerala6 from '../images/statewiseCards/Kerala/6.png';
import kerala7 from '../images/statewiseCards/Kerala/7.png';
import kerala8 from '../images/statewiseCards/Kerala/8.png';
import kerala9 from '../images/statewiseCards/Kerala/9.png';
import kerala10 from '../images/statewiseCards/Kerala/10.png';
import kerala11 from '../images/statewiseCards/Kerala/11.png';
import kerala12 from '../images/statewiseCards/Kerala/12.png';



// ladakh
import ladakh1 from '../images/statewiseCards/Ladakh/1.png';
import ladakh2 from '../images/statewiseCards/Ladakh/2.png';
import ladakh3 from '../images/statewiseCards/Ladakh/3.png';
import ladakh4 from '../images/statewiseCards/Ladakh/4.png';
import ladakh5 from '../images/statewiseCards/Ladakh/5.png';
import ladakh6 from '../images/statewiseCards/Ladakh/6.png';
import ladakh7 from '../images/statewiseCards/Ladakh/7.png';

// north eash
import northeast1 from '../images/statewiseCards/North East/1.png'
import northeast2 from '../images/statewiseCards/North East/2.png'
import northeast3 from '../images/statewiseCards/North East/3.png'

// himachal
import himachal from '../images/statewiseCards/Himachal/1.png'
import himacha2 from '../images/statewiseCards/Himachal/2.png'
import himacha3 from '../images/statewiseCards/Himachal/3.png'
import himacha7 from '../images/statewiseCards/Himachal/4.png'

import himacha16 from '../images/statewiseCards/Himachal/16.png'
import himacha17 from '../images/statewiseCards/Himachal/17.png'
import himacha18 from '../images/statewiseCards/Himachal/18.png'
import himacha19 from '../images/statewiseCards/Himachal/19.png'
import himacha20 from '../images/statewiseCards/Himachal/20.png'
import himacha21 from '../images/statewiseCards/Himachal/21.png'
import himacha22 from '../images/statewiseCards/Himachal/22.png'
import himacha23 from '../images/statewiseCards/Himachal/23.png'
import himacha24 from '../images/statewiseCards/Himachal/24.png'
import himacha25 from '../images/statewiseCards/Himachal/25.png'
import himacha26 from '../images/statewiseCards/Himachal/26.png'
import himacha27 from '../images/statewiseCards/Himachal/27.png'
import himacha28 from '../images/statewiseCards/Himachal/28.png'

// Kashmir
import Kashmir1 from '../images/statewiseCards/Kashmir/1.png'
import Kashmir2 from '../images/statewiseCards/Kashmir/2.png'
import Kashmir3 from '../images/statewiseCards/Kashmir/3.png'
import Kashmir4 from '../images/statewiseCards/Kashmir/4.png'
import Kashmir5 from '../images/statewiseCards/Kashmir/5.png'


// Rajsthan
import rajsthan1 from '../images/statewiseCards/Rajsthan/1.png';
import rajsthan2 from '../images/statewiseCards/Rajsthan/2.png';
import rajsthan3 from '../images/statewiseCards/Rajsthan/3.png';
import rajsthan4 from '../images/statewiseCards/Rajsthan/4.png';
import rajsthan5 from '../images/statewiseCards/Rajsthan/5.png';
import rajsthan6 from '../images/statewiseCards/Rajsthan/6.png';
import rajsthan7 from '../images/statewiseCards/Rajsthan/7.png';
import rajsthan8 from '../images/statewiseCards/Rajsthan/8.png';
import rajsthan9 from '../images/statewiseCards/Rajsthan/9.png';
import rajsthan10 from '../images/statewiseCards/Rajsthan/10.png';
import rajsthan11 from '../images/statewiseCards/Rajsthan/11.png';
import rajsthan12 from '../images/statewiseCards/Rajsthan/12.png';
import rajsthan13 from '../images/statewiseCards/Rajsthan/13.png';
import rajsthan14 from '../images/statewiseCards/Rajsthan/13.png';


// Sikkim - Darjeeling

import SikkimDarjeeling1 from '../images/statewiseCards/Sikkim Darjeeling/1.png';
import SikkimDarjeeling2 from '../images/statewiseCards/Sikkim Darjeeling/2.png';

// Bangalore
// import bangalore1 from '../images/statewiseCards/Bangalore.png';

// Chennai
import chennai1 from '../images/statewiseCards/Channai.png';


// Hyderabad
import hyderabad1 from '../images/statewiseCards/Hydrabad.png';

// Mumbai
import mumbai1 from '../images/statewiseCards/Mumbai/1.png';
import mumbai2 from '../images/statewiseCards/Mumbai/2.png';


// New Delhi
import newDelhi1 from '../images/statewiseCards/New Delhi/1.png';
import newDelhi2 from '../images/statewiseCards/New Delhi/3.png';
import newDelhi3 from '../images/statewiseCards/New Delhi/3.png';
import newDelhi4 from '../images/statewiseCards/New Delhi/4.png';


// Others
import others1 from '../images/statewiseCards/Others/1.png';
import others2 from '../images/statewiseCards/Others/2.png';
import others3 from '../images/statewiseCards/Others/3.png';
import others4 from '../images/statewiseCards/Others/4.png';
import others5 from '../images/statewiseCards/Others/5.png';
import others6 from '../images/statewiseCards/Others/6.png';


// Gujarat
import gujarat1 from '../images/statewiseCards/Gujrat/1.png';
import gujarat2 from '../images/statewiseCards/Gujrat/2.png';

// Uttarakhand
import uttarakhand1 from '../images/statewiseCards/Uttarakhand/1.png';
import uttarakhand2 from '../images/statewiseCards/Uttarakhand/2.png';
import uttarakhand3 from '../images/statewiseCards/Uttarakhand/3.png';
import uttarakhand4 from '../images/statewiseCards/Uttarakhand/4.png';
import uttarakhand5 from '../images/statewiseCards/Uttarakhand/5.png';
import uttarakhand6 from '../images/statewiseCards/Uttarakhand/6.png';
import uttarakhand7 from '../images/statewiseCards/Uttarakhand/7.png';
import uttarakhand8 from '../images/statewiseCards/Uttarakhand/8.png';
import uttarakhand9 from '../images/statewiseCards/Uttarakhand/9.png';
import uttarakhand10 from '../images/statewiseCards/Uttarakhand/10.png';
import uttarakhand11 from '../images/statewiseCards/Uttarakhand/11.png';
import uttarakhand12 from '../images/statewiseCards/Uttarakhand/12.png';
import uttarakhand13 from '../images/statewiseCards/Uttarakhand/13.png';
import uttarakhand14 from '../images/statewiseCards/Uttarakhand/14.png';
import uttarakhand15 from '../images/statewiseCards/Uttarakhand/15.png';
import uttarakhand16 from '../images/statewiseCards/Uttarakhand/16.png';
import uttarakhand17 from '../images/statewiseCards/Uttarakhand/17.png';
import uttarakhand18 from '../images/statewiseCards/Uttarakhand/18.png';
import uttarakhand19 from '../images/statewiseCards/Uttarakhand/19.png';


// Uttar Pradesh
import up1 from '../images/statewiseCards/Uttar pradesh/1.png';
import up2 from '../images/statewiseCards/Uttar pradesh/2.png';
import up3 from '../images/statewiseCards/Uttar pradesh/3.png';

// West Bengal
import westBengal from '../images/statewiseCards/Westbengal/1.png';
import westBenga2 from '../images/statewiseCards/Westbengal/2.png';
import westBenga3 from '../images/statewiseCards/Westbengal/3.png';

// Punjab
import punjab1 from '../images/statewiseCards/Punjab.png';

// Tamil Nadu
import tamilNadu1 from '../images/statewiseCards/Tamil nadu/1.png';
import tamilNadu2 from '../images/statewiseCards/Tamil nadu/2.png';
import tamilNadu3 from '../images/statewiseCards/Tamil nadu/3.png';
import tamilNadu4 from '../images/statewiseCards/Tamil nadu/4.png';
import tamilNadu5 from '../images/statewiseCards/Tamil nadu/5.png';
import tamilNadu6 from '../images/statewiseCards/Tamil nadu/6.png';
import tamilNadu7 from '../images/statewiseCards/Tamil nadu/7.png';
import tamilNadu8 from '../images/statewiseCards/Tamil nadu/8.png';

// Karnataka
import karnataka1 from '../images/statewiseCards/Karanatak/1.png';
import karnataka2 from '../images/statewiseCards/Karanatak/2.png';
import karnataka3 from '../images/statewiseCards/Karanatak/3.png';
import karnataka4 from '../images/statewiseCards/Karanatak/4.png';
import karnataka5 from '../images/statewiseCards/Karanatak/5.png';
import karnataka6 from '../images/statewiseCards/Karanatak/6.png';
import karnataka7 from '../images/statewiseCards/Karanatak/7.png';
import karnataka8 from '../images/statewiseCards/Karanatak/8.png';
import karnataka9 from '../images/statewiseCards/Karanatak/9.png';
import karnataka10 from '../images/statewiseCards/Karanatak/10.png';
import karnataka11 from '../images/statewiseCards/Karanatak/11.png';
import karnataka12 from '../images/statewiseCards/Karanatak/12.png';

// odisha
import odisha1 from '../images/statewiseCards/Odisha/1.png';
import odisha2 from '../images/statewiseCards/Odisha/2.png';
import odisha3 from '../images/statewiseCards/Odisha/3.png';

// Maharashtra
import maharashtra1 from '../images/statewiseCards/Maharashtra/1.png';
import maharashtra2 from '../images/statewiseCards/Maharashtra/2.png';
import maharashtra3 from '../images/statewiseCards/Maharashtra/3.png';

export const StateWiseCards  = [
{
  stateName:'Andaman',
  tourName:'4 Nights/ 5 Days-Andaman Package',
  tourImg:andaman1,
  tourPrice:'15,500',
  days:'5',
  night:'4',
  pdfLink:'https://drive.google.com/file/d/1JrMSEC-avaE_pG29vQQcTa-4yfYO7mOH/view?usp=sharing'
},
{
  stateName:'Andaman',
  tourName:'6N Mesmerizing Andaman',
  tourImg:andaman10,
  tourPrice:'28,000',
  days:'0',
  night:'6',
  pdfLink:'https://drive.google.com/file/d/1o7yA2Di0GLNErjBhICVClToS7cjMzUcs/view?usp=sharing'
},
//best1
{     
  stateName:'Andaman',
  tourName:'4N Andaman Tour',
  tourImg:andaman3,
  tourPrice:'15,000',
  days:'5',
  night:'4',
  pdfLink:'https://drive.google.com/file/d/1gyVtcOofSiuVDr96bBY1WEx__2KNzodL/view?usp=sharing'
},
{
  stateName:'Andaman',
  tourName:'5N Exotic Andaman',
  tourImg:andaman4,
  tourPrice:'22999',
  days:'0',
  night:'5',
  pdfLink:'https://drive.google.com/file/d/1H-1eee59mln6hVWr4KzNW3oJ0_T52GVu/view?usp=sharing'
},
{
  stateName:'Andaman',
  tourName:'3N Andaman Tour | Port Blair & Havelock Island',
  tourImg:andaman5,
  tourPrice:'16999',
  days:'0',
  night:'3',
  pdfLink:'https://drive.google.com/file/d/1kupG505N2bMFCSJ9zVC28nWaC3uFUf29/view?usp=sharing'
},
{
  stateName:'Andaman',
  tourName:'3N Andaman Tour',
  tourImg:andaman6,
  tourPrice:'17500',
  days:'0',
  night:'3',
  pdfLink:'https://drive.google.com/file/d/1DBzQ83gBkIZicQcdhjHhLjw36AQi9tNZ/view?usp=sharing'
},
{
  stateName:'Andaman',
  tourName:'3N Magical Andaman Island Package',
  tourImg:andaman7,
  tourPrice:'15,999',
  days:'0',
  night:'3',
  pdfLink:'https://drive.google.com/file/d/1pIe4pUlRPMT3LjTRqjYKF-Gl0FTzhb3z/view?usp=sharing'
},
{
  stateName:'Andaman',
  tourName:'3N Andaman Tour | Port Blair',
  tourImg:andaman8,
  tourPrice:'16500',
  days:'0',
  night:'3',
  pdfLink:'https://drive.google.com/file/d/1jQIwXxoOe0Z60Wklaxx2P1lGi6eYVXL8/view?usp=sharing'
},
{
  stateName:'Andaman',
  tourName:'3N Ultimate Andaman Experience',
  tourImg:andaman9,
  tourPrice:'14500',
  days:'0',
  night:'3',
  pdfLink:'https://drive.google.com/file/d/11ybsi_aEalsJGSyNVRyujUQNgXWMq5j9/view?usp=sharing'
},
{
  stateName:'Andaman',
  tourName:'4N Andaman Honeymooners Paradise',
  tourImg:andaman10,
  tourPrice:'20999',
  days:'0',
  night:'4',
  pdfLink:'https://drive.google.com/file/d/1OnnMtK2DEPya2ud6LDupkC0ItVwYDJbb/view?usp=sharing'
},
{
  stateName:'Andaman',
  tourName:'5N Andaman package',
  tourImg:andaman11,
  tourPrice:'17,500',
  days:'6',
  night:'5',
  pdfLink:'https://drive.google.com/file/d/1zdEC_Ze4JGRGEYzclTetA0naGU4ccII7/view?usp=sharing'
},
{
  stateName:'Andaman',
  tourName:'5N Glimpse of Andaman Island',
  tourImg:andaman13,
  tourPrice:'23999',
  days:'6',
  night:'5',
  pdfLink:'https://drive.google.com/file/d/1y4UziGQek4ePKrRIdsaLAhv3OKAuu_OX/view?usp=sharing'
},
{
  stateName:'Andaman',
  tourName:'2N Andaman Tour |',
  tourImg:andaman14,
  tourPrice:'8999',
  days:'3',
  night:'2',
  pdfLink:'https://drive.google.com/file/d/1Q5R1Dpujft5CWH8UPqrloNf4TvsWBp5O/view?usp=sharing'
},
{
  stateName:'Andaman',
  tourName:'3N - Andaman Paradise ',
  tourImg:andaman15,
  tourPrice:'14999',
  days:'4',
  night:'3',
  pdfLink:'https://drive.google.com/file/d/17YToqs1RX4_GJ81YCq25EVqefDKYc-uI/view?usp=sharing'
},
{
  stateName:'Andaman',
  tourName:'Port Blair, Havelock & Neil',
  tourImg:andaman16,
  tourPrice:'26989',
  days:'7',
  night:'6',
  pdfLink:'https://drive.google.com/file/d/1DgHS11osgIujiVKssti14vNhBh74cue1/view?usp=sharing'
},
{
  stateName:'Andaman',
  tourName:'Port Blair, Havelock, Neil, Ross Island And Diglipur',
  tourImg:andaman17,
  tourPrice:'46999',
  days:'9',
  night:'8',
  pdfLink:'https://drive.google.com/file/d/1UV6ysndONwaNFlc3GcDSnYiUlJAD7r-x/view?usp=sharing'
},
{
  stateName:'Andaman',
  tourName:'5N Amazing Andaman (3 Star Hotel)',
  tourImg:andaman18,
  tourPrice:'26999',
  days:'6',
  night:'5',
  pdfLink:'https://drive.google.com/file/d/1FlISMxoESYWELuLuZlBkY1nMdyP98NQL/view?usp=sharing'
},
{
  stateName:'Andaman',
  tourName:'5N Andaman Package (3 Star Hotels)',
  tourImg:andaman19,
  tourPrice:'24500',
  days:'6',
  night:'5',
  pdfLink:'https://drive.google.com/file/d/1qC0Na9RGc2JTw3aIzZaJNZX5J8YlRi6E/view?usp=sharing'
},
{
  stateName:'Andaman',
  tourName:'Port Blair, Havelock, Elephant Beach, Baratang',
  tourImg:andaman20,
  tourPrice:'20999',
  days:'5',
  night:'4',
  pdfLink:'https://drive.google.com/file/d/1aoYHOQy0DVVpzeQlewo71kidlIPWJMet/view?usp=sharing'
},
{
  stateName:'Andaman',
  tourName:'4N Andaman Tour (3 Star Hotels)',
  tourImg:andaman21,
  tourPrice:'18999',
  days:'5',
  night:'4',
  pdfLink:'https://drive.google.com/file/d/1z1vGQwbKUof6NZD-1Xcu1kt4YmnUgksM/view?usp=sharing'
},
{
  stateName:'Andaman',
  tourName:'Port Blair, Neil And Chidiyatapu',
  tourImg:andaman22,
  tourPrice:'16999',
  days:'4',
  night:'3',
  pdfLink:'https://drive.google.com/file/d/1nQwdeCrw9ab5LHC3Cktk37fcTWy7ALmu/view?usp=sharing'
},
{
  stateName:'Andaman',
  tourName:'4N Andaman',
  tourImg:andaman12,
  tourPrice:'15,700',
  days:'5',
  night:'4',
  pdfLink:'https://drive.google.com/file/d/16n9MiTAkqm4M02n0euA-2_u9fouBqkpf/view?usp=sharing'
},


// CHAR DHAM
// best2
{
  stateName:'Char Dham',
  tourName:'Serene Chardham Yatra',
  tourImg:chardham1,
  tourPrice:'36,000',
  days:'9',
  night:'8',
  pdfLink:'https://drive.google.com/file/d/13idzC-vxfzj6Rkh_9xhsP0KOrC1rBrGx/view?usp=sharing'
},
{
  stateName:'Char Dham',
  tourName:'Gangotri, Kedarnath, Badrinath',
  tourImg:chardham2,
  tourPrice:'21,999',
  days:'9',
  night:'8',
  pdfLink:'https://drive.google.com/file/d/1jFBMTYykvFLYRi7EKmL24-POtryFgFGd/view?usp=sharing'
},

// GOA

{
  stateName:'Goa',
  tourName:'Lemon Tree Hotel, Candolim, Goa',
  tourImg:goa1,
  tourPrice:'4,332',
  days:'',
  night:'1',
pdfLink:'https://drive.google.com/file/d/1ETjn0FAsUNMUfQPg9_pLj6KmPN7mseBT/view?usp=sharing'
},
{
  stateName:'Goa',
  tourName:'Lemon Tree Amarante Beach Resort - GOA',
  tourImg:'',
  tourPrice:'5,486',
 
  night:'1',
pdfLink:'https://drive.google.com/file/d/1X7aYCUd9xyaeawTiAoflLxg3nkNrzDE3/view?usp=sharing'
},
{
  stateName:'Goa',
  tourName:'Lambana Resort - Calangute Goa',
  tourImg:goa2,
  tourPrice:'2,626',
  
  night:'1',
pdfLink:'https://drive.google.com/file/d/1E56g8ZluB77d1bkHsO-ykFKWYf9lVtij/view?usp=sharing'
},

{
  stateName:'Goa',
  tourName:'Arrival Transfer: Dabolim Airport to accommodation',
  tourImg:goa3,
  tourPrice:'2,420',
  
pdfLink:'https://drive.google.com/file/d/13fqufFBlVBrrvLTGhQPQ9XaxE4fqL3_v/view?usp=sharing'
},
{
  stateName:'Goa',
  tourName:'Scuba diving + Watersports, Goa',
  tourImg:goa4,
  tourPrice:'4,050',
  
pdfLink:'https://drive.google.com/file/d/1R5HLzYiBv-SwvSNdEaSLEAHzP-5hoyvQ/view?usp=sharing'
},
// best3
{
  stateName:'Goa',
  tourName:'Charming Goa',
  tourImg:goa5,
  tourPrice:'9,999',
  days:'4',
  night:'3',
  pdfLink:'https://drive.google.com/file/d/112ByYo0mTCpa4b6Q_b7Ahagl3N-dXEd-/view?usp=sharing'
},

// GOLDEN TRIANGLE
// best4
{
  stateName:'Golden Triangle',
  tourName:'Majestic Golden Triangle',
  tourImg:goldenTriangle1,
  tourPrice:'17,250',
  days:'6',
  night:'5',
  pdfLink:'https://drive.google.com/file/d/1h-lPIE3bhADsYM_hl2bIWyGWEIYld3DP/view?usp=sharing'
},
{
  stateName:'Golden Triangle',
  tourName:'Golden Triangle Package',
  tourImg:goldenTriangle2,
  tourPrice:'6,800',
  days:'5',
  night:'4',
  pdfLink:'https://drive.google.com/file/d/1c8hhAkSGvPqyTOyvkbRPpNo_BlCmDgDG/view?usp=sharing'
},
{
  stateName:'Golden Triangle',
  tourName:'Golden Triangle Tour',
  tourImg:goldenTriangle3,
  tourPrice:'15,999',
  days:'7',
  night:'6',
  pdfLink:'https://drive.google.com/file/d/1xAsBarZQ_nPqEi8rlWHRMdM8HgVk2D_n/view?usp=sharing'
},


// KERALA
// best5
{
  stateName:'Kerala',
  tourName:'Exclusive Kerala Honeymoon Package',
  tourImg:kerala1,
  tourPrice:'12,500',
  days:'4',
  night:'3',
  pdfLink:'https://drive.google.com/file/d/1gBLpBKAJo8Eu3nFWJjVLAoxksSrXGFO4/view?usp=sharing'
},
{
  stateName:'Kerala',
  tourName:'The Patio, Thekkady',
  tourImg:kerala2,
  tourPrice:'1,750',
  days:'',
  night:'1',
  pdfLink:'https://drive.google.com/file/d/1j6ok1iFIzSaDfWnrTmfqH4qW9sVyvFoc/view?usp=sharing'
},
{
  stateName:'Kerala',
  tourName:'Houseboat Experience In Kochi',
  tourImg:kerala3,
  tourPrice:'4,150',
  days:'',
  night:'',
  pdfLink:'https://drive.google.com/file/d/1G15b0xRk8753ACAkm8H3TJKbr7fPBzPi/view?usp=sharing'
},
{
  stateName:'Kerala',
  tourName:'Kochin To Kovalam',
  tourImg:kerala4,
  tourPrice:'1,370',
  days:'',
  night:'',
  pdfLink:'https://drive.google.com/file/d/1azuEiZJUmoxqQqPCGnwbtg_quOkL3uCH/view?usp=sharing'
},
{
  stateName:'Kerala',
  tourName:'Exotic Kerala',
  tourImg:kerala5,
  tourPrice:'25,999',
  days:'8',
  night:'7',
  pdfLink:'https://drive.google.com/file/d/1qhLcYir0VPPoQ-MWk04P0_QlGakYYIb-/view?usp=sharing'
},
{
  stateName:'Kerala',
  tourName:'Getaway to Kerala',
  tourImg:kerala6,
  tourPrice:'17,500',
  days:'4',
  night:'5',
  pdfLink:'https://drive.google.com/file/d/1KOgsAit0_5iY4tscPk9lKSdlXIt_VnIO/view?usp=sharing'
},
{
  stateName:'Kerala',
  tourName:'Kerala Tour (3 Star Package)',
  tourImg:kerala7,
  tourPrice:'11,999',
  days:'4',
  night:'3',
  pdfLink:'https://drive.google.com/file/d/1IN0RX3V517kMVXMjJxZNyCr6R0bhdJU5/view?usp=drive_link'
},
{
  stateName:'Kerala',
  tourName:' Glimpse of Kerala',
  tourImg:kerala8,
  tourPrice:'22,500',
  days:'7',
  night:'6',
  pdfLink:'https://drive.google.com/file/d/1_1DgKo3NYJnThPHPpYKc0Wvs0D3T-1BL/view?usp=drive_link'
},
{
  stateName:'Kerala',
  tourName:'Awesome Munnar',
  tourImg:kerala9,
  tourPrice:'9,500',
  days:'3',
  night:'2',
  pdfLink:'https://drive.google.com/file/d/1yGY0DS4nDoJKt5Aify6UOMo_a_Uo0cCC/view?usp=drive_link'
},
{
  stateName:'Kerala',
  tourName:'Charming Kerala with Houseboat Stay',
  tourImg:kerala10,
  tourPrice:'15,500',
  days:'4',
  night:'3',
  pdfLink:'https://drive.google.com/file/d/1ySTYHnH_Z2KbMVPjklb_4Njv0QaI7WXm/view?usp=drive_link'
},
{
  stateName:'Kerala',
  tourName:' Kerala Tour Package',
  tourImg:kerala11,
  tourPrice:'26,000',
  days:'7',
  night:'6',
  pdfLink:'https://drive.google.com/file/d/13so8vwoeROH1iZJAFl5c61UsJ6_47UX5/view?usp=drive_link'
},
{
  stateName:'Kerala',
  tourName:'Amazing Kerala Tour',
  tourImg:kerala12,
  tourPrice:'14,300 ',
  days:'5',
  night:'4',
  pdfLink:'https://drive.google.com/file/d/1bJBZeq6zOfQdgfd57uQnDkIeITRdCnVL/view?usp=drive_link'
},


//  LADAKH
// best6
{
  stateName:'Ladakh',
  tourName:'Explore Ladakh',
  tourImg:ladakh1,
  tourPrice:'35,000',
  days:'8',
  night:'7',
  pdfLink:'https://drive.google.com/file/d/1CTfag5dKqVmvAN4ouKZ2XRls4uHpykbD/view?usp=sharing'
},
{
  stateName:'Ladakh',
  tourName:'Ladakh - Leh And Pangong - Hotel Millenium',
  tourImg:ladakh2,
  tourPrice:'19,999',
  days:'4',
  night:'3',
  pdfLink:'https://drive.google.com/file/d/1En0OG5vikaxdEKM_Z6IpUNldAGle3XYe/view?usp=sharing'
},
{
  stateName:'Ladakh',
  tourName:'Ladakah - Leh, Sham Valley And Pangong Lake - Green View',
  tourImg:ladakh3,
  tourPrice:'25,999',
  days:'5',
  night:'4',
  pdfLink:'https://drive.google.com/file/d/1Nlczu9rJsscezNOd9GQBBzHFRvRnz2tI/view?usp=sharing'
},
{
  stateName:'Ladakh',
  tourName:'Ladakh - Leh, Nubra and Pangong - Grand Nubra',
  tourImg:ladakh4,
  tourPrice:'28,999',
  days:'5',
  night:'4',
  pdfLink:'https://drive.google.com/file/d/1LbxLaZ11R8gqI7mJ6xSwwqcp3H5Eu6gT/view?usp=sharing'
},
{
  stateName:'Ladakh',
  tourName:'Leh, Sham Valley, Khardungla Top',
  tourImg:ladakh5,
  tourPrice:'20,999',
  days:'4',
  night:'3',
  pdfLink:'https://drive.google.com/file/d/13d9yXTcRHy1lhgXmsNv9CVXN7QoWBiai/view?usp=sharing'
},
{
  stateName:'Ladakh',
  tourName:'Leh, Sham Valley, Khardungla Top & Pangong Lake',
  tourImg:ladakh6,
  tourPrice:'29,999',
  days:'5',
  night:'4',
  pdfLink:'https://drive.google.com/file/d/1JUKoJxKIvu4nV6-roy1h9ykprcFkV1JO/view?usp=sharing'
},
{
  stateName:'Ladakh',
  tourName:' Leh, Nubra Valley & Pangong Lake',
  tourImg:ladakh7,
  tourPrice:'36,000',
  days:'6',
  night:'5',
  pdfLink:'https://drive.google.com/file/d/1NwRbnJ5oFVJNL8mOyoElmRVgwXOBT6Wg/view?usp=sharing'
},


//  NORTH EAST
// best7
{
  stateName:'North East',
  tourName:' Northeast - Guwahati and Shillong',
  tourImg:northeast1,
  tourPrice:'13250',
  days:'6',
  night:'5',
  pdfLink:'https://drive.google.com/file/d/1V2O6U2yvqY_o8Th-ffpahQ5Zuc4wwXVG/view?usp=sharing'
},
{
  stateName:'North East',
  tourName:' Assam Adventure',
  tourImg:northeast2,
  tourPrice:'17250',
  days:'5',
  night:'4',
  pdfLink:'https://drive.google.com/file/d/1u15gtTFzAYRZzGb-y8suWheUF33XiHS3/view?usp=sharing'
},
{
  stateName:'North East',
  tourName:'  Assam Wildlife',
  tourImg:northeast3,
  tourPrice:'18,999',
  days:'6',
  night:'5',
  pdfLink:'https://drive.google.com/file/d/1QEFfZ0X8LYopMD_2xEDC0gzO18mEA0PA/view?usp=sharing'
},


//  HIMACHAL

{
  stateName:'Himachal',
  tourName:' Amara Resort Manali',
  tourImg:himachal,
  tourPrice:'2000',
  days:'',
  night:'1',
  pdfLink:'https://drive.google.com/file/d/1fbhpGfsXUH6S_vWvD8l5zMnWECyUPF8B/view?usp=sharing'
},


{
  stateName:'Himachal',
  tourName:' Amara Resorts Manali',
  tourImg:himacha2,
  tourPrice:'2,079',
  days:'',
  night:'1',
  pdfLink:'https://drive.google.com/file/d/1ot9IsmFHW2XODfwIgHRB_Zbu2WTaaWVe/view?usp=sharing'
},
{
  stateName:'Himachal',
  tourName:' Amara Blue Magnet, Dalhousie',
  tourImg:himacha3,
  tourPrice:' 2,541',
  days:'',
  night:'0',
  pdfLink:'https://drive.google.com/file/d/1mzeevViokPcFvJGtDIEYBOyohz6oMzoZ/view?usp=sharing'
},
{
  stateName:'Himachal',
  tourName:'Delhi - Kasol (1N) - Rudranag (1N) - Delhi',
  tourImg:'',
  tourPrice:'6,750',
  days:'3',
  night:'2',
  pdfLink:'https://drive.google.com/file/d/17gq4s51ESCpEZKrBbSiJEIgtAt8mfPz_/view?usp=sharing'
},
{
  stateName:'Himachal',
  tourName:'Nibaana - A Luxury Resort in Dharamshala',
  tourImg:'8,661',
  tourPrice:' 8,661 ',
  days:'',
  night:'1',
  pdfLink:'https://drive.google.com/file/d/14cPaSopzZLScGGmcOlgS-XVmK71rA7vs/view?usp=sharing'
},
{
  stateName:'Himachal',
  tourName:'Timber Trail Resort, Parwanoo - Himachal Pradesh',
  tourImg:'',
  tourPrice:'4,810',
  days:'',
  night:'1',
  pdfLink:'https://drive.google.com/file/d/1jcSR27U2zrWCCmpWA1aAAtWA7-08HeFS/view?usp=sharing'
},
// best8
{
  stateName:'Himachal',
  tourName:'Delhi - Kasol (1N) - Kheerganga (1N) - Delhi',
  tourImg:himacha7,
  tourPrice:' 6,700',
  days:'3',
  night:'2',
  pdfLink:'https://drive.google.com/file/d/1hIGbFkDiou7tfsotquroB3rhwxvGXh3V/view?usp=sharing'
},
{
  stateName:'Himachal',
  tourName:'The Terrace - Parwanoo - Himachal',
  tourImg:'',
  tourPrice:'8,800',
  days:'',
  night:'1',
  pdfLink:'https://drive.google.com/file/d/1bjqdbMpPBY3NFXhmwQO35igp-OfSvDfq/view?usp=sharing'
},
{
  stateName:'Himachal',
  tourName:'Moksha Himalaya Spa Resort Parwanoo',
  tourImg:'',
  tourPrice:'24,200',
  days:'3',
  night:'2',
  pdfLink:'https://drive.google.com/file/d/1a-AbmICy_R4S7lXfjJUzgiP6ySK8Tmvv/view?usp=sharing'
},
{
  stateName:'Himachal',
  tourName:' Luxury Manali Tour Package',
  tourImg:'',
  tourPrice:'11,500',
  days:'5',
  night:'4',
  pdfLink:'https://drive.google.com/file/d/1VhY4wQmh0caAj9FFlYEWOF8yjgAc7hXT/view?usp=sharing'
},
{
  stateName:'Himachal',
  tourName:'Shimla, Manali, Dalhousie, Dharamshala, and Chandigarh',
  tourImg:himacha16,
  tourPrice:'33,000',
  days:'10',
  night:'9',
  pdfLink:'https://drive.google.com/file/d/1QEFfZ0X8LYopMD_2xEDC0gzO18mEA0PA/view?usp=sharing'
},
{
  stateName:'Himachal',
  tourName:'Shimla, Manali, Dalhousie, Dharamshala, and Chandigarh',
  tourImg:himacha16,
  tourPrice:'33,000',
  days:'10',
  night:'9',
  pdfLink:'https://drive.google.com/file/d/1QEFfZ0X8LYopMD_2xEDC0gzO18mEA0PA/view?usp=sharing'
},
{
  stateName:'Himachal',
  tourName:' Manali, Shimla, & Delhi',
  tourImg:himacha17,
  tourPrice:'21,999',
  days:'7',
  night:'6',
  pdfLink:'https://drive.google.com/file/d/1QEFfZ0X8LYopMD_2xEDC0gzO18mEA0PA/view?usp=sharing'
},
{
  stateName:'Himachal',
  tourName:'Himachal, Delhi and Agra',
  tourImg:himacha18,
  tourPrice:'28,000',
  days:'3',
  night:'2',
  pdfLink:'https://drive.google.com/file/d/1QEFfZ0X8LYopMD_2xEDC0gzO18mEA0PA/view?usp=sharing'
},
{
  stateName:'Himachal',
  tourName:'Manali via Volvo Bus',
  tourImg:himacha19,
  tourPrice:' 9,999',
  days:'3',
  night:'2',
  pdfLink:'https://drive.google.com/file/d/1QEFfZ0X8LYopMD_2xEDC0gzO18mEA0PA/view?usp=sharing'
},
{
  stateName:'Himachal',
  tourName:' Kasauli, Shimla, Dharamshala, Dalhousie, and Manali',
  tourImg:himacha20,
  tourPrice:' 36,000',
  days:'11',
  night:'10',
  pdfLink:'https://drive.google.com/file/d/1QEFfZ0X8LYopMD_2xEDC0gzO18mEA0PA/view?usp=sharing'
},
{
  stateName:'Himachal',
  tourName:' Shimla, Manali, And Chandigarh',
  tourImg:himacha21,
  tourPrice:'21,000',
  days:'7',
  night:'6',
  pdfLink:'https://drive.google.com/file/d/1QEFfZ0X8LYopMD_2xEDC0gzO18mEA0PA/view?usp=sharing'
},
{
  stateName:'Himachal',
  tourName:'Kinnaur and Spiti Valley',
  tourImg:himacha22,
  tourPrice:'28,999',
  days:'8',
  night:'7',
  pdfLink:'https://drive.google.com/file/d/1QEFfZ0X8LYopMD_2xEDC0gzO18mEA0PA/view?usp=sharing'
},
{
  stateName:'Himachal',
  tourName:' Manali and Chandigarh',
  tourImg:himacha23,
  tourPrice:'21,800',
  days:'6',
  night:'5',
  pdfLink:'https://drive.google.com/file/d/1QEFfZ0X8LYopMD_2xEDC0gzO18mEA0PA/view?usp=sharing'
},
{
  stateName:'Himachal',
  tourName:' Shimla, Himachal Pradesh',
  tourImg:himacha24,
  tourPrice:'14,999',
  days:'5',
  night:'3',
  pdfLink:'https://drive.google.com/file/d/1QEFfZ0X8LYopMD_2xEDC0gzO18mEA0PA/view?usp=sharing'
},
{
  stateName:'Himachal',
  tourName:' Shimla and Chail',
  tourImg:himacha25,
  tourPrice:'17,000',
  days:'4',
  night:'3',
  pdfLink:'https://drive.google.com/file/d/1QEFfZ0X8LYopMD_2xEDC0gzO18mEA0PA/view?usp=sharing'
},

{
  stateName:'Himachal',
  tourName:'Shimla, Manali, and Chandigarh',
  tourImg:himacha26,
  tourPrice:'16,900',
  days:'7',
  night:'6',
  pdfLink:'https://drive.google.com/file/d/1QEFfZ0X8LYopMD_2xEDC0gzO18mEA0PA/view?usp=sharing'
},
{
  stateName:'Himachal',
  tourName:'Dharamshala, Dalhousie, & Amritsar',
  tourImg:himacha27,
  tourPrice:'15,999',
  days:'6',
  night:'5',
  pdfLink:'https://drive.google.com/file/d/1QEFfZ0X8LYopMD_2xEDC0gzO18mEA0PA/view?usp=sharing'
},
{
  stateName:'Himachal',
  tourName:'Manali, Kullu, & Solang',
  tourImg:himacha28,
  tourPrice:'9,500',
  days:'4',
  night:'3',
  pdfLink:'https://drive.google.com/file/d/1QEFfZ0X8LYopMD_2xEDC0gzO18mEA0PA/view?usp=sharing'
},


// KASHMIR

// best9
{
  stateName:'Kashmir',
  tourName:'Royal Tour Of Kashmir',
  tourImg:Kashmir1,
  tourPrice:'13,570',
  days:'6',
  night:'5',
  pdfLink:'https://drive.google.com/file/d/1E_NhhtpohqwLDmpIK1fFx7if1oDaKYV0/view?usp=sharing'
},
{
  stateName:'Kashmir',
  tourName:'Pearls of Jammu and Kashmir',
  tourImg:Kashmir2,
  tourPrice:'24,000',
  days:'7',
  night:'6',
  pdfLink:'https://drive.google.com/file/d/1OwdsTSMaZq2ySdJ3NPSsGL_UNrb3-h_b/view?usp=sharing'
},
{
  stateName:'Kashmir',
  tourName:'Mata Vaishnodevi Darshan',
  tourImg:Kashmir3,
  tourPrice:'27,000',
  days:'9',
  night:'8',
  pdfLink:'https://drive.google.com/file/d/1w2BF-5b8tCujws-oB0gjeXL3GerPLV-K/view?usp=sharing'
},
{
  stateName:'Kashmir',
  tourName:'Kashmir Exploration',
  tourImg:Kashmir4,
  tourPrice:'14,000',
  days:'7',
  night:'6',
  pdfLink:'https://drive.google.com/file/d/1w2BF-5b8tCujws-oB0gjeXL3GerPLV-K/view?usp=sharing'
},
{
  stateName:'Kashmir',
  tourName:'Exotic Three Sisters',
  tourImg:Kashmir5,
  tourPrice:'19,999',
  days:'6',
  night:'5',
  pdfLink:'https://drive.google.com/file/d/1p-ZrZOSmiJa2QiJBTGySifZcGNzNUw56/view?usp=sharing'
},


//  Rajasthan


{
  stateName:'Rajasthan',
  tourName:' Luxury Cottages with Private Pool...',
  tourImg:rajsthan1,
  tourPrice:'19,000',
  days:'',
  night:'2', 
  pdfLink:'https://drive.google.com/file/d/1WzRUl1w5GDlFWSbkg2IypU312H0mnzzw/view?usp=sharing' 
},
{
  stateName:'Rajasthan',
  tourName:'Deluxe Nest at The Tree House Resort, Jaipur',
  tourImg:rajsthan2,
  tourPrice:'9,900',
  days:'',
  night:'2',
  pdfLink:'https://drive.google.com/file/d/1euqduw5yWHBnuxGZ_lIKpEssRUp_thte/view?usp=sharing'
},
{
  stateName:'Rajasthan',
  tourName:'2N Rajasthan | Udaipur | Hotel King Fisher',
  tourImg:rajsthan3,
  tourPrice:'14,500 ',
  days:'3',
  night:'2',
  pdfLink:'https://drive.google.com/file/d/1jcdllEwv2zYPNaYQ5PwVOqc5bOFWAQz0/view?usp=drive_link'
},
// best10
{
  stateName:'Rajasthan',
  tourName:'Tijara Fort Palace, Tijara',
  tourImg:rajsthan4,
  tourPrice:' 6,380',
  days:'',
  night:'',
  pdfLink:'https://drive.google.com/file/d/1i2g-kN0-5crheVtKgEtCRzEp0wauTwuy/view?usp=sharing'
},
{
  stateName:'Rajasthan',
  tourName:'Luxury Garden & Spa Villa at The Tree of Life Resort...',
  tourImg:rajsthan5,
  tourPrice:'8,635 ',
  days:'0',
  night:'2',
  pdfLink:'https://drive.google.com/file/d/1Z3tUBbXpSYUOAoYNA3_XYaqXtsxMu6Th/view?usp=sharing'
},
{
  stateName:'Rajasthan',
  tourName:'Luxury Garden & Spa Villa - Jaipur',
  tourImg:rajsthan6,
  tourPrice:'9,125',
  days:'0',
  night:'1',
  pdfLink:'https://drive.google.com/file/d/1a80wENFGJq7n6IrrjDIsNC4YWU0wc623/view?usp=sharing'
},
{
  stateName:'Rajasthan',
  tourName:'2 Nights at Ranthambore Hideaway Garden Cottage',
  tourImg:rajsthan7,
  tourPrice:'6,270',
  days:'0',
  night:'2',
  pdfLink:'https://drive.google.com/file/d/1dkfmgHVPcmY7dNCFZCwZ30nOH-6rljEs/view?usp=sharing'
},
{
  stateName:'Rajasthan',
  tourName:'2 Nights at Ranthambore Hideaway Garden Cottage',
  tourImg:rajsthan8,
  tourPrice:'5,899',
  days:'0',
  night:'2',
  pdfLink:'https://drive.google.com/file/d/16aCu070d6ZMbFJ9NoWdIgmEO0MrOM_TM/view?usp=drive_link'
},
{
  stateName:'Rajasthan',
  tourName:'Hari Mahal Palace - Jaipur',
  tourImg:rajsthan9,
  tourPrice:'2,310',
  days:'0',
  night:'1',
  pdfLink:'https://drive.google.com/file/d/1PaYTJ4FOVRXJOejHlUlmesHEj6Sv2rlq/view?usp=drive_link'
},
{
  stateName:'Rajasthan',
  tourName:'Jaisalmer Sightseeing With Sam Sand Dunes',
  tourImg:rajsthan10,
  tourPrice:'600',
  days:'',
  night:'',
  pdfLink:'https://drive.google.com/file/d/1M7R4urJEPWN71ePFeo5f9xch9O5l2Lyi/view?usp=drive_link'
},
{
  stateName:'Rajasthan',
  tourName:'2N Rajasthan | Jaipur | Hotel King Palace',
  tourImg:rajsthan11,
  tourPrice:'10,000',
  days:'3',
  night:'2',
  pdfLink:'https://drive.google.com/file/d/1VkOydP67jCz08WdBfHEg6fn1Fw86Xb75/view?usp=drive_link'
},
{
  stateName:'Rajasthan',
  tourName:'2N Rajasthan | Jaisalmer | Hotel Meera Mahal',
  tourImg:rajsthan12,
  tourPrice:'15,000',
  days:'3',
  night:'2',
  pdfLink:'https://drive.google.com/file/d/1xHgANLkpuVJ2pwazy_r1RJFO4nSTB19X/view?usp=drive_link'
},
{
  stateName:'Rajasthan',
  tourName:'2N Rajasthan | Ranthambhore | Hotel Sher Vilas',
  tourImg:rajsthan13,
  tourPrice:'14,000',
  days:'3',
  night:'2',
  pdfLink:'https://drive.google.com/file/d/1yU1m9IykZal38-_cfGgF9EQPK1iaP5a5/view?usp=drive_link'
},
{
  stateName:'Rajasthan',
  tourName:'7N Rajasthan Tour | Jaisalmer, Jodhpur, Mount Abu, Udaipur, Pushkar',
  tourImg:rajsthan14,
  tourPrice:'27,720',
  days:'8',
  night:'7',
  pdfLink:'https://drive.google.com/file/d/1VHmqSPTy-hLp2PDRsDcq3rl1fXauxigl/view?usp=drive_link'
},


// Sikkim - Darjeeling
{
  stateName:'Sikkim - Darjeeling',
  tourName:'5N View Darjeeling + Kalimpong + Gangtok In Budget',
  tourImg:SikkimDarjeeling1,
  tourPrice:'24,500',
  days:'6',
  night:'5',
  pdfLink:'https://drive.google.com/file/d/1bLsOMF8zuLKmDL86y8oMVHYFdpLc6weF/view?usp=drive_link'
},
{
  stateName:'Sikkim - Darjeeling',
  tourName:'4N Northeast - Gangtok and Darjeeling',
  tourImg:SikkimDarjeeling2,
  tourPrice:'25,999',
  days:'5',
  night:'4',
  pdfLink:'https://drive.google.com/file/d/1E8GN1o9q2zx1jY6rBKCQzEfd7DK8AnK7/view?usp=drive_link'
},


//  Bangalore
{
  stateName:'Bangalore',
  tourName:'Please share your details to get the best customized offer.',
  tourImg:'',
  tourPrice:'',
  days:'',
  night:'',
},
// Chennai

{
  stateName:'Chennai',
  tourName:'Exotic South India Package',
  tourImg:chennai1,
  tourPrice:'17,850',
  days:'5',
  night:'4',
  pdfLink:'https://drive.google.com/file/d/1kjATn4-3TQhglIPQelQx_a_h9chKwJ9B/view?usp=drive_link'
},

//  Hyderabad
{
  stateName:'Hyderabad',
  tourName:'Amazing Andhra Pradesh',
  tourImg:hyderabad1,
  tourPrice:'22,425',
  days:'7',
  night:'6',
  pdfLink:'https://drive.google.com/file/d/12R13I62Ggju-IY5J9LktA54mMimOfjiw/view?usp=drive_link'
},

//  Lucknow

// Mumbai
{
  stateName:'Mumbai',
  tourName:'Mumbai Tour Package',
  tourImg:mumbai1,
  tourPrice:'8,650',
  days:'4',
  night:'3',
  pdfLink:'https://drive.google.com/file/d/1Dpnaqzr0hpBJHqRhC83lPw6_jhzFkQmC/view?usp=drive_link'
},
{
  stateName:'Mumbai',
  tourName:'Amazing Mumbai Tour package',
  tourImg:mumbai2,
  tourPrice:'9,800',
  days:'4',
  night:'3',
  pdfLink:'https://drive.google.com/file/d/1W962yTfLVEwwrqp1dLDu9VKby5FwnC6v/view?usp=drive_link'
},

//  New Delhi

{
  stateName:'New Delhi',
  tourName:'ITC Grand Bharat',
  tourImg:newDelhi1,
  tourPrice:'14,298',
  days:'0',
  night:'1',
  pdfLink:'https://drive.google.com/file/d/14e3foDFMTtO8k-BusikXZOiHiy59Y1KC/view?usp=drive_link'
},

{
  stateName:'New Delhi',
  tourName:'New Zealand Visa',
  tourImg:newDelhi2,
  tourPrice:' 11,500',
  days:'',
  night:'',
  pdfLink:'https://drive.google.com/file/d/1d-5biO-K8rE27uDjege-L8GbLqDr-VnW/view?usp=drive_link'
},
{
  stateName:'New Delhi',
  tourName:'Untouched South New Zealand',
  tourImg:newDelhi3,
  tourPrice:'1,50,000 ',
  days:'7',
  night:'7',
  pdfLink:'https://drive.google.com/file/d/18FdGNfpnYaps0m6-T8Xx4JabIYrJlqEz/view?usp=drive_link'
},
{
  stateName:'New Delhi',
  tourName:'7 Nights & 8 Days Scenic South Island in Newzealand',
  tourImg:newDelhi4,
  tourPrice:'95,000',
  days:'8',
  night:'7',
  pdfLink:'https://drive.google.com/file/d/1W962yTfLVEwwrqp1dLDu9VKby5FwnC6v/view?usp=drive_link'
},

// Pune

// others
{
  stateName:'Others',
  tourName:'3N Beautiful Bangladesh',
  tourImg:others1,
  tourPrice:'50,600',
  days:'4',
  night:'3',
  pdfLink:'https://drive.google.com/file/d/1f-x5eYKq2UBO-G5nBHRJIbSqNHY3ynyU/view?usp=drive_link'
},
{
  stateName:'Others',
  tourName:'6Nights Philippines - Cebu, Bohol & Manila',
  tourImg:others2,
  tourPrice:'17,400',
  days:'7',
  night:'6',
  pdfLink:'https://drive.google.com/file/d/12vgSbft2Yftn0IWODMIn27n3XWKaIYzD/view?usp=drive_link'
},
{
  stateName:'Others',
  tourName:'Pachmarhi Hill Station',
  tourImg:others3,
  tourPrice:'5,200',
  days:'3',
  night:'2',
  pdfLink:'https://drive.google.com/file/d/176u95nyDubo4LFiaph8K0RMdOANu1lPn/view?usp=drive_link'
},
{
  stateName:'Others',
  tourName:'Madhya Pradesh Wildlife',
  tourImg:others4,
  tourPrice:' 9,200',
  days:'7',
  night:'6',
  pdfLink:'https://drive.google.com/file/d/1lBltTcnkW-Nq8nVhaaetBvtkRzooPK7z/view?usp=drive_link'
},
{
  stateName:'Others',
  tourName:'Canada Sticker Visa',
  tourImg:others5,
  tourPrice:'13,500',
  days:'',
  night:'',
  pdfLink:'https://drive.google.com/file/d/1ThjQhKW7v2q7TbRFKKVYN_4CQdcUJNnn/view?usp=drive_link'
},
{
  stateName:'Others',
  tourName:'Pondicherry',
  tourImg:others6,
  tourPrice:'9,800',
  days:'4',
  night:'3',
  pdfLink:'https://drive.google.com/file/d/1iZ6IJXBSW_131j90mN8JL1sACXOIrBKa/view?usp=drive_link'
},

//  Gujarat

{
  stateName:'Gujarat',
  tourName:'Vibrant Gujarat Tour',
  tourImg:gujarat1,
  tourPrice:'11,500',
  days:'6',
  night:'5',
   pdfLink:'https://drive.google.com/file/d/1yRwdG9gOmLMu6cPzmyhw8yyEliOYE_nF/view?usp=drive_link'
},
{
  stateName:'Gujarat',
  tourName:'Mumbai - Ahmedabad - Wankaner - Gir - Rajkot.',
  tourImg:gujarat2,
  tourPrice:'17,250',
  days:'9',
  night:'8',
   pdfLink:'https://drive.google.com/file/d/1rrOUmbVOjLIm-mF1uyvtJF6zuNV0aw1u/view?usp=drive_link'
},

// Uttarakhand


{
  stateName:'Uttarakhand',
  tourName:'The Glasshouse on the Ganges, Rishikesh',
  tourImg:uttarakhand1,
  tourPrice:'9,817',
  days:'',
  night:'',
  pdfLink:'https://drive.google.com/file/d/1Odg5ja-a5VVLCmkKnmlHsdgX4AbohVFq/view?usp=drive_link'
},
{
  stateName:'Uttarakhand',
  tourName:'Hotel Naini View - Nainital',
  tourImg:uttarakhand2,
  tourPrice:' 2,657',
  days:'0',
  night:'1',
  pdfLink:'https://drive.google.com/file/d/11bjX0M64si1b6B83jXSmL8JMEmLWgAdQ/view?usp=drive_link'
},
{
  stateName:'Uttarakhand',
  tourName:'The Alpine Chalet Resort – Mukteshwar',
  tourImg:uttarakhand3,
  tourPrice:'5,198',
  days:'0',
  night:'1',
  pdfLink:'https://drive.google.com/file/d/1ZycxrT6v2N7mNMboA6OWKAB_IlV6N80-/view?usp=drive_link'
},
{
  stateName:'Uttarakhand',
  tourName:'Nainital Tour Package From Delhi',
  tourImg:uttarakhand4,
  tourPrice:'12,100',
  days:'3',
  night:'2',
  pdfLink:'https://drive.google.com/file/d/1AABcSfmU5yGIpid0hhxT8DHDzjrZ_PSJ/view?usp=drive_link'
},
{
  stateName:'Uttarakhand',
  tourName:'LA Savanna Resort, Jim Corbett',
  tourImg:uttarakhand5,
  tourPrice:'4,043',
  days:'0',
  night:'1',
  pdfLink:'https://drive.google.com/file/d/15lAoEbmGLOudMxslHBBw7iMpm8arGryl/view?usp=drive_link'
},
{
  stateName:'Uttarakhand',
  tourName:'Winsome Resort & SPA, Jim Corbett',
  tourImg:uttarakhand6,
  tourPrice:'3,850',
  days:'0',
  night:'1',
  pdfLink:'https://drive.google.com/file/d/1hXKBtdC7ogP0mVdAnob3TGQdrVwL_h6W/view?usp=drive_link'
},
{
  stateName:'Uttarakhand',
  tourName:'Corbett Jungle Leela, Jim Corbett',
  tourImg:uttarakhand7,
  tourPrice:'4,430',
  days:'0',
  night:'1',
  pdfLink:'https://drive.google.com/file/d/1N70oeUY-Bc8hVT0D-lZ-ZqeChzof_PAd/view?usp=drive_link'
},
{
  stateName:'Uttarakhand',
  tourName:'Corbett Tigers & Trees, Jim Corbett',
  tourImg:uttarakhand8,
  tourPrice:'3,465',
  days:'0',
  night:'1',
  pdfLink:'https://drive.google.com/file/d/1mgHQE5HNFLte4M2dTLX40UTR3rPSkH0J/view?usp=drive_link'
},
{
  stateName:'Uttarakhand',
  tourName:'Amara The High Walls, Mussoorie',
  tourImg:uttarakhand9,
  tourPrice:'2,890',
  days:'0',
  night:'1',
  pdfLink:'https://drive.google.com/file/d/1h68RZrMDWDf8N4CAQnpHN9LrZqTvr1p2/view?usp=drive_link'
},
{
  stateName:'Uttarakhand',
  tourName:'Bagheera Jungle Retreat Resort, Jim Corbett',
  tourImg:uttarakhand10,
  tourPrice:'3,119',
  days:'0',
  night:'1',
  pdfLink:'https://drive.google.com/file/d/1yLaLTUpbnabpC4l7W_PjMFLYC5JLR5-x/view?usp=drive_link'
},
{
  stateName:'Uttarakhand',
  tourName:'Hotel Holiday Highlights Corbett - Jim Corbett',
  tourImg:uttarakhand11,
  tourPrice:'3,119',
  days:'0',
  night:'1',
  pdfLink:'https://drive.google.com/file/d/1_eScs9hCu1_QRadwF9S0YAHvzwxaH1ww/view?usp=drive_link'
},
{
  stateName:'Uttarakhand',
  tourName:'Delhi - Joshimath (2N) - Auli - Delhi',
  tourImg:uttarakhand12,
  tourPrice:'7,290',
  days:'3',
  night:'2',
  pdfLink:'https://drive.google.com/file/d/1turht-dD0FKZ-Gl2Qt5sr4ZzyTzHLnl6/view?usp=drive_link'
},
{
  stateName:'Uttarakhand',
  tourName:'Delhi - Chopta (2N) - Delhi',
  tourImg:uttarakhand13,
  tourPrice:'7100',
  days:'3',
  night:'2',
  pdfLink:'https://drive.google.com/file/d/1asF5xH1w03qwKFa9swvYaew-la372G--/view?usp=drive_link'
},
{
  stateName:'Uttarakhand',
  tourName:'Aura The Kund Resort Jim Corbett',
  tourImg:uttarakhand14,
  tourPrice:'4,050',
  days:'0',
  night:'1',
  pdfLink:'https://drive.google.com/file/d/1U3T1ghuvqtsGwk_8qCh31i7tjeGvOAHm/view?usp=drive_link'
},
{
  stateName:'Uttarakhand',
  tourName:'CHARDHAM YATRA',
  tourImg:uttarakhand15,
  tourPrice:'24,725',
  days:'12',
  night:'11',
  pdfLink:'https://drive.google.com/file/d/12q8NUCHl4cksSOBMo-cJ3kMx_NpApLYy/view?usp=drive_link'
},
{
  stateName:'Uttarakhand',
  tourName:'Corbett Nainital Tour Package',
  tourImg:uttarakhand16,
  tourPrice:'5,750',
  days:'4',
  night:'3',
  pdfLink:'https://drive.google.com/file/d/1-We1f3BnnUhfYXn1lqS6cEdnXK5Wc2cc/view?usp=drive_link'
},
{
  stateName:'Uttarakhand',
  tourName:'Haridwar and Mussoorie',
  tourImg:uttarakhand17,
  tourPrice:'8,625',
  days:'5',
  night:'4',
  pdfLink:'https://drive.google.com/file/d/1jeqoNFN-me0I0e3mfYlM09yeslYRnNSW/view?usp=drive_link'
},
{
  stateName:'Uttarakhand',
  tourName:'Nainital Package',
  tourImg:uttarakhand18,
  tourPrice:'17,825',
  days:'9',
  night:'8',
  pdfLink:'https://drive.google.com/file/d/1Jy72FTXFmslDAKQuck3vyspTOWad2OLS/view?usp=drive_link'
},
{
  stateName:'Uttarakhand',
  tourName:'Haridwar, Rishikesh, Chopta Valley, And Mussoorie',
  tourImg:uttarakhand19,
  tourPrice:'15,525',
  days:'7',
  night:'6',
  pdfLink:'https://drive.google.com/file/d/1IZAJbl4ONW3vF49TQzRBOb56hjqSisMU/view?usp=drive_link'
},

// Uttar Pradesh

{
  stateName:'Uttar Pradesh',
  tourName:'Day Tour of Kashi Special Darshan & Ganga Aarti',
  tourImg:up1,
  tourPrice:'3,450',
  days:'',
  night:'',
  pdfLink:'https://drive.google.com/file/d/1ty_4eWB1JaMar8bd3MmBrrKo71hoA_iT/view?usp=drive_link'
},
{
  stateName:'Uttar Pradesh',
  tourName:'Complete Kashi Yatra',
  tourImg:up2,
  tourPrice:'19,000',
  days:'7',
  night:'6',
  pdfLink:'https://drive.google.com/file/d/1ymgrHh5K1cDzBmM0I05uWBsg4v_-jvPp/view?usp=drive_link'
},
{
  stateName:'Uttar Pradesh',
  tourName:'Varanasi Package',
  tourImg:up3,
  tourPrice:'10,120',
  days:'5',
  night:'4',
  pdfLink:'https://drive.google.com/file/d/1zdjboHDr6FV8DR3pRAcjSC8v6SrJX1p7/view?usp=drive_link'
},


// West Bengal

{
  stateName:'West Bengal',
  tourName:'Offbeat Home Stay in Bhalukhop',
  tourImg:westBengal,
  tourPrice:'2,650',
  days:'0',
  night:'0',
  pdfLink:'https://drive.google.com/file/d/1aBNyClDHTxPTofCPjXRc-EyJELIgGNHq/view?usp=drive_link'
},
{
  stateName:'West Bengal',
  tourName:'Offbeat Homestay in Lungchu amongst Nature',
  tourImg:westBenga2,
  tourPrice:'2,150',
  days:'0',
  night:'1',
  pdfLink:'https://drive.google.com/file/d/1IWVCcfBSOol-eHJQw-82qCaaf9suXZGw/view?usp=drive_link'
},
{
  stateName:'West Bengal',
  tourName:'Sundarban Tiger Cruise',
  tourImg:westBenga3,
  tourPrice:' 5,200',
  days:'3',
  night:'2',
  pdfLink:'https://drive.google.com/file/d/1cbp9ceKkY5dtoXIsq7ceDYJMPv9X0yGp/view?usp=drive_link'
},

// Bihar

// Punjab
{
  stateName:'Punjab',
  tourName:'The Baradari Palace, Patiala',
  tourImg:punjab1,
  tourPrice:'4,900',
  days:'0',
  night:'1',
  pdfLink:'https://drive.google.com/file/d/1diF18k_Ty6v0EusMnCDKUrstSVxEjkyC/view?usp=drive_link'
},

// Tamil Nadu

{
  stateName:'Tamil Nadu',
  tourName:'The Bungalow on the Beach, Tamil Nadu',
  tourImg:tamilNadu1,
  tourPrice:'5,339',
  days:'0',
  night:'0',
  pdfLink:'https://drive.google.com/file/d/1q7m-jZVZBmGUxYkjFuj8LgXRopFUxAaB/view?usp=drive_link'
},
{
  stateName:'Tamil Nadu',
  tourName:'Wallwood Garden, Tamil Nadu',
  tourImg:tamilNadu2,
  tourPrice:'4,900',
  days:'0',
  night:'0',
  pdfLink:'https://drive.google.com/file/d/1zuu7NXVzR7XKAJEXHD3VWinjBm9bn9PP/view?usp=drive_link'
},
{
  stateName:'Tamil Nadu',
  tourName:'2 Nights in Luxury Suite at Tamara Kodaikanal',
  tourImg:tamilNadu3,
  tourPrice:'16,000',
  days:'0',
  night:'2',
  pdfLink:'https://drive.google.com/file/d/1j4qyVMybwUN9_N9hh7iYmp5KMzcqnbTh/view?usp=drive_link'
},
{
  stateName:'Tamil Nadu',
  tourName:'2 nights in Deluxe Heritage Room at Chettinadu Mansion, Kanadukathan',
  tourImg:tamilNadu4,
  tourPrice:'5,699 ',
  days:'0',
  night:'2',
  pdfLink:'https://drive.google.com/file/d/1RavWst0q_bEGnYQPowBLRfmrJ1ao8YqA/view?usp=drive_link'
},
{
  stateName:'Tamil Nadu',
  tourName:'Ooty: Jungle Camping and adventure',
  tourImg:tamilNadu5,
  tourPrice:'1,499',
  days:'0',
  night:'0',
  pdfLink:'https://drive.google.com/file/d/1e456lfPm32qGrUThyMLHXR4nLvm5DqEg/view?usp=drive_link'
},
{
  stateName:'Tamil Nadu',
  tourName:'Mysore, Nagarhole, And Ooty',
  tourImg:tamilNadu6,
  tourPrice:'14,400',
  days:'7',
  night:'6',
  pdfLink:'https://drive.google.com/file/d/1l66ON2ru-S9VEQpQqR6QHfNbiuSKDHFU/view?usp=drive_link'
},
{
  stateName:'Tamil Nadu',
  tourName:'2 Nights 3 Days in Ooty',
  tourImg:tamilNadu7,
  tourPrice:'4,100',
  days:'3',
  night:'2',
  pdfLink:'https://drive.google.com/file/d/1LNwfM7wW7yog53rEk_tIQrQKZMXFfTVV/view?usp=drive_link'
},
{
  stateName:'Tamil Nadu',
  tourName:' Hidden Treasures of South India',
  tourImg:tamilNadu8,
  tourPrice:'21,850',
  days:'14',
  night:'13',
  pdfLink:'https://drive.google.com/file/d/1d9VlDCeikSf_EohIBqwozHUjzrk8zeUJ/view?usp=drive_link'
},


// Karnataka
{
  stateName:'Karnataka',
  tourName:'COORG - AYATANA',
  tourImg:karnataka1,
  tourPrice:'11,586',
  days:'',
  night:'',
  pdfLink:'https://drive.google.com/file/d/1YCZuNYIkmJdU6RMKZtK0j7BjJj6czMwa/view?usp=sharing'
},
{
  stateName:'Karnataka',
  tourName:'2 Nights in Superior Room at Club Mahindra Madikeri, Coorg',
  tourImg:karnataka2,
  tourPrice:'11,000',
  days:'0',
  night:'2',
  pdfLink:''
},
{
  stateName:'Karnataka',
  tourName:'2 Nights in Luxury Cottage at Tamara Coorg- Weekend Offer - Full Board',
  tourImg:karnataka3,
  tourPrice:'24,900',
  days:'0',
  night:'2',
  pdfLink:'https://drive.google.com/file/d/1e1-qVua0lLPf-vtNyripAkD6kV7CAgN4/view?usp=drive_link'
},
{
  stateName:'Karnataka',
  tourName:'2 Nights in Guddadamane at Varshini Estate- Sakleshpur',
  tourImg:karnataka4,
  tourPrice:'5,899',
  days:'0',
  night:'2',
  pdfLink:'https://drive.google.com/file/d/1iigS_EMIk7xBFGlXX8t5CtiZqgBLYfyo/view?usp=drive_link'
},
{
  stateName:'Karnataka',
  tourName:'3 Nights in Luxury Tent at Camp Serai Tiger, Moharli',
  tourImg:karnataka5,
  tourPrice:' 13,750',
  days:'0',
  night:'3',
  pdfLink:'https://drive.google.com/file/d/1pOOqPPKsuyLhFKFdVK9pNzTeOlcDpkGh/view?usp=drive_link'
},
{
  stateName:'Karnataka',
  tourName:'2 Nights in Coorg at Upper Stone Cottage , Linger Farm',
  tourImg:karnataka6,
  tourPrice:'5,899',
  days:'0',
  night:'2',
  pdfLink:'https://drive.google.com/file/d/1WmquZHszHfuZFTmJMc5mZvVRNnJYAhhB/view?usp=drive_link'
},
{
  stateName:'Karnataka',
  tourName:'2 Nights Grand Mercure Mysuru',
  tourImg:karnataka7,
  tourPrice:'3,850 ',
  days:'0',
  night:'2',
  pdfLink:'https://drive.google.com/file/d/1GkT04sxKt1mC82roSVIDEhA9up-iZwgW/view?usp=drive_link'
},
{
  stateName:'Karnataka',
  tourName:'3N - Karnataka - Mysore And Wayanad - Wayanad Winds',
  tourImg:karnataka8,
  tourPrice:'11,850',
  days:'4',
  night:'3',
  pdfLink:'https://drive.google.com/file/d/1xCuf-kisU5HkqvuweRdNs7807UsXU7-9/view?usp=drive_link'
},
{
  stateName:'Karnataka',
  tourName:'6N Karnataka - Bangalore, Mysore, Wayanad And Ooty - Mount Avenue',
  tourImg:karnataka9,
  tourPrice:'22,450',
  days:'7',
  night:'6',
  pdfLink:'https://drive.google.com/file/d/1Ea7svQ2-8MyR0zmUG-4zSS7slgBPpmEO/view?usp=drive_link'
},
{
  stateName:'Karnataka',
  tourName:'7N Karnataka - Bangalore, Mysore, Ooty And Kodaikanal - Saffron Suites',
  tourImg:karnataka10,
  tourPrice:'25,950',
  days:'8',
  night:'7',
  pdfLink:'https://drive.google.com/file/d/1RA2PWISgPk_g9-On5ZEzx0waJLbohvcU/view?usp=drive_link'
},
{
  stateName:'Karnataka',
  tourName:'2N Gokarna Luxury Villa Tour',
  tourImg:karnataka11,
  tourPrice:'16,150',
  days:'3',
  night:'2',
  pdfLink:'https://drive.google.com/file/d/1i5xV__7-U7yUBHEIZkJwusEH533BQGMv/view?usp=drive_link'
},
{
  stateName:'Karnataka',
  tourName:'3 Nights & 4 Days in Mysore & Coorg',
  tourImg:karnataka12,
  tourPrice:'13,250',
  days:'4',
  night:'3',
  pdfLink:'https://drive.google.com/file/d/1w6F803bgZkOR4ABNu4nEkKtXg9ApyPbE/view?usp=drive_link'
},


// Odisha

{
  stateName:'Odisha',
  tourName:'4N Odisha Eco Tribal Tour',
  tourImg:odisha1,
  tourPrice:'16,100',
  days:'5',
  night:'4',
  pdfLink:'https://drive.google.com/file/d/18lbnTEIiL1i5NWMl_qDJcWARkGudI82j/view?usp=drive_link'
},
{
  stateName:'Odisha',
  tourName:'6N Offbeat Odisha Luxury Tour Package',
  tourImg:odisha2,
  tourPrice:'40,250',
  days:'7',
  night:'6',
  pdfLink:'https://drive.google.com/file/d/1r5afHpaqKQvysXuz5bvwQzc4KdgMd947/view?usp=drive_link'
},
{
  stateName:'Odisha',
  tourName:'3N Odisha Golden triangle',
  tourImg:odisha3,
  tourPrice:'12,650',
  days:'4',
  night:'3',
  pdfLink:'https://drive.google.com/file/d/13-fsXWs4sDKcoZPAPStaYpOjITTgsgdx/view?usp=drive_link'
},

// Maharashtra

{
  stateName:'Maharashtra',
  tourName:'MAHARASHTRA - TADOBA VANYA VILLAS',
  tourImg:maharashtra1,
  tourPrice:'12,128',
  days:'0',
  night:'1',
  pdfLink:'https://drive.google.com/file/d/1-5TqGEoFXAeAD_QnDWMhjIs5vtjxdFuz/view?usp=drive_link'
},
{
  stateName:'Maharashtra',
  tourName:'The Heritage Mile Walk In Mumbai',
  tourImg:maharashtra2,
  tourPrice:'1,750 ',
  days:'0',
  night:'0',
  pdfLink:'https://drive.google.com/file/d/1elu0Jol8_S8c5lus1mUHKZxTvXdGJXs8/view?usp=drive_link'
},
{
  stateName:'Maharashtra',
  tourName:'Central India Wildlife Tour',
  tourImg:maharashtra3,
  tourPrice:'43,700',
  days:'6',
  night:'5',
  pdfLink:'https://drive.google.com/file/d/1ZXHuUGe4rR0cti0IFvhSZiKCQDW3p0HN/view?usp=drive_link'
},



]